/**
 * Event Flow section wrapper.
 *
 * Routing:
 *   /event-flow                         → Reports listing
 *   /event-flow?preset=...              → Standalone builder (deep link)
 *   /event-flow/new                     → New event flow report builder
 *   /event-flow/reports/:id             → Saved report builder
 */
import { SectionPage } from '@/components/layout/SectionPage';
import { EventFlowBuilder } from './EventFlowBuilder';

export function EventFlowPage() {
  return (
    <SectionPage
      basePath="/event-flow"
      BuilderComponent={EventFlowBuilder}
      queryParamKeys={['preset', 'start']}
    />
  );
}
